export const clusters = [
    { id: "elektrotechnika", hu: "Elektrotechnika", en: "Electrotechnics", faIcon: "plug"},
    { id: "mikroelektronika", hu: "Mikroelektronika és nanotechnológia", en: "Microelectronics and nanotechnology", faIcon: "microchip"},
    { id: "beagyazott", hu: "Beágyazott rendszerek", en: "Embedded systems", faIcon: "robot"},
    { id: "halozatok", hu: "Hálózatok", en: "Networks", faIcon: "network-wired"},
    { id: "jelfeldolgozas", hu: "Jelfeldolgozás", en: "Signal processing", faIcon: "wave-square"},
    { id: "orvosi", hu: "Orvosi informatika", en: "Medical informatics", faIcon: "laptop-medical"},
    //{ id: "vallalati", hu: "Vállalati rendszerek", en: "Enterprise systems", faIcon: "file-invoice-dollar"},
    { id: "urtechnologia", hu: "Űrtechnológia és vezetéknélküli rendszerek", en: "Space technology and wireless systems", faIcon: "satellite"},
    { id: "itrendszerek", hu: "Szoftver rendszerek fejlesztése és biztonsága", en: "Development and security of software systems", faIcon: "code"},
    //{ id: "adattudomany", hu: "Adattudomány és big data", en: "Data science and big data technology", faIcon: "database"},
    { id: "intelligens", hu: "Mesterséges intelligencia és adattudomány", en: "Artificial intelligence and data science", faIcon: "brain"},
    
];

export const groups = [
    {
        id: "teljesitmenyelektronika",        
        cluster: ["elektrotechnika"] ,
        hu: "Teljesítményelektronika",
        en: "Power electronics",
        file: { hu: "AUT/teljesítményelektronika.json", en: "AUT/teljesítményelektronika_en.json"}
    },
    {
        id: "nagyfeszultesegutechnika",        
        cluster: ["elektrotechnika"] ,
        hu: "Nagyfeszültségű technika",
        en: "High power technology",
        file: { hu: "VET/nagyfeszultsegutechnika.json", en: "VET/nagyfeszultsegutechnika_en.json"}
    },
    {
        id: "villamosgepekesszabalyozotthajtasok",        
        cluster: ["elektrotechnika"] ,
        hu: "Villamos gépek és szabályozott hajtások",
        en: "Electrical machines and controlled drives",
        file: { hu: "VET/villamosgepekesszabalyozotthajtasok.json", en: "VET/villamosgepekesszabalyozotthajtasok_en.json"}
    },
    {
        id: "villamosenergiarendszerek",        
        cluster: ["elektrotechnika"] ,
        hu: "Villamosenergia-rendszerek",
        en: "Power systems",
        file: { hu: "VET/villamosenergiarendszerek.json", en: "VET/villamosenergiarendszerek_en.json"}
    },
    {
        id: "faster",        
        cluster: ["elektrotechnika"] ,
        hu: "MTA-BME Lendület FASTER",
        en: "MTA-BME Lendület FASTER",
        file: { hu: "VET/faster.json", en: "VET/faster_en.json"}
    },
    {
        id: "smartpower",        
        cluster: ["elektrotechnika"] ,
        hu: "Smart Power",
        en: "Smart Power",
        file: { hu: "VET/smartpower.json", en: "VET/smartpower_en.json"}
    },
    {
        id: "chipmeretulaborok",        
        cluster: ["mikroelektronika"] ,
        hu: "Chipméretű laboratóriumok",
        en: "Chip-sized laboratories",
        file: { hu: "EET/mikrofluidika.json", en: "EET/mikrofluidika_en.json"}
    },
    {
        id: "napelemekmikroesnanoelektronika",        
        cluster: ["mikroelektronika"] ,
        hu: "Napelemek, nano- és mikroelektronika",
        en: "Photovoltaic systems, nano- and microelectronics",
        file: { hu: "EET/mikroelektronika.json" }
    },
    {
        id: "szilardtestvilagitastechnika",        
        cluster: ["mikroelektronika"] ,
        hu: "Szilárdtest világítástechnika",
        en: "Solid-state lighting systems",
        file: { hu: "EET/szilardtestvilagitastechnika.json" }
    },
    {
        id: "termikusmenedzsment",        
        cluster: ["mikroelektronika"] ,
        hu: "Elektronikai rendszerek termikus és megbízhatósági kérdései",
        en: "Thermal management, electronics cooling and reliability",
        file: { hu: "EET/termikusmenedzsment.json" }
    },
    {
        id: "kotestechnologiak",        
        cluster: ["mikroelektronika"] ,
        hu: "Kötés technológiák és áramköri hordozók",
        en: "Packaging technologies",
        file: { hu: "ETT/kotestechnologia.json", en: "ETT/kotestechnologia_en.json" }
    },
    {
        id: "elektronikaimegbizhatosag",        
        cluster: ["mikroelektronika"] ,
        hu: "Elektronikai megbízhatóság, hibaanalitika",
        en: "Microelectronics reliability and failure analysis",
        file: { hu: "ETT/elektronikaimegbizhatosag.json" }
    },
    {
        id: "nanotechnologiaszenzorika",        
        cluster: ["mikroelektronika"] ,
        hu: "Nanotechnológia, szenzorika",
        en: "Nanotechnology, sensors",
        file: { hu: "ETT/nanotechnologiaszenzorika.json", en: "ETT/nanotechnologiaszenzorika_en.json"}
    },
    {
        id: "beagyazottrendszerekesrobotika",        
        cluster: ["beagyazott"] ,
        hu: "Beágyazott rendszerek és robotika",
        en: "Embedded systems and robotics",
        file: { hu: "AUT/beágyazottrendszerekésrobotika.json", en: "AUT/beágyazottrendszerekésrobotika_en.json"}
    },
    {
        id: "digitaliscelrendszerek",        
        cluster: ["beagyazott"] ,
        hu: "Digitális célrendszerek",
        en: "Digital systems and applications",
        file: { hu: "IIT/digitáliscélrendszerek.json", en: "IIT/digitáliscélrendszerek_en.json"}
    },
    {
        id: "valosidejubeagyazottrendszerek",        
        cluster: ["beagyazott"] ,
        hu: "Heterogén, valós-idejű elosztott beágyazott rendszerek",
        en: "Heterogenous real-time distributed embedded Systems",
        file: { hu: "MIT/hálózatbakapcsoltbeágyazottrendszerek.json"}
    },
    {
        id: "iranyitastechniaesrobotika",        
        cluster: ["beagyazott", "intelligens"] ,
        hu: "Irányítástechnika és robotika",
        en: "Control engineering and robotics",
        file: { hu: "IIT/irányítástechnikaésrobotika.json"}
    },
    {
        id: "mikrohullamuesoptikaitavkozles",        
        cluster: ["halozatok", "urtechnologia", "jelfeldolgozas"] ,
        hu: "Mikrohullámú és optikai távközlő rendszerek",
        en: "Microwave and optical telecommunication systems",
        file: { hu: "HVT/mikrohullámúésoptikai.json"}
    },
    {
        id: "halozatiszolgaltatasokesiot",        
        cluster: ["halozatok"] ,
        hu: "SmartComLab - Hálózati szolgáltatások és IoT menedzsment",
        en: "SmartComLab - Network services and IoT management",
        file: { hu: "TMIT/hálózatiszolgáltatásokésiot.json", en: "TMIT/hálózatiszolgáltatásokésiot_en.json"}
    },
    {
        id: "hsnlabjovointernet",        
        cluster: ["halozatok"] ,
        hu: "HSNLab - Jövő internet",
        en: "HSNLab - Future Internet",
        file: { hu: "TMIT/hsnlabjövőinternet.json"}
    },
    {
        id: "hsnlabhalozatszooftverizacio",
        cluster: ["halozatok"] ,
        hu: "HSNLab - Hálózatszoftverizálás és felhő alapú rendszerek",
        en: "HSNLab - Network softwerization and cloud systems",
        file: { hu: "TMIT/hsnlabhálózatszoftverizálás.json"}
    },
    {
        id: "hsnlabszenzorhalozatok",
        cluster: ["halozatok"] ,
        hu: "HSNLab - Szenzorhálózatok és IoT",
        en: "HSNLab - Sensor networks and IoT",
        file: { hu: "TMIT/hsnlabszenzorhálózatok.json"}
    },
    {
        id: "halozatitechnologiak",
        cluster: ["halozatok"] ,
        hu: "Hálózati technológiák",
        en: "Network technologies",
        file: { hu: "HIT/hálózatitechnológiák.json" }
    },
    {
        id: "intelligenskozlekedesirendszerel",
        cluster: ["halozatok", "intelligens"] ,
        hu: "Intelligens közlekedési rendszerek",
        en: "Intelligent transportation systems",
        file: { hu: "HIT/intelligensközlekedés.json", en: "HIT/intelligensközlekedés_en.json" }
    },
    {
        id: "kvantumkommunikacioesinformatika",
        cluster: ["halozatok", "urtechnologia"] ,
        hu: "Kvantumkommunikáció és informatika",
        en: "Quantum communication and computing",
        file: { hu: "HIT/kvantumkommunikáció.json"}
    },
    {
        id: "algoritmuselmelet",
        cluster: ["halozatok", "itrendszerek"] ,
        hu: "Algoritmuselmélet",
        en: "Algorithm theory",
        file: { hu: "SZIT/algoritmuselmélet.json"}
    },
    {
        id: "akusztika",
        cluster: ["jelfeldolgozas"] ,
        hu: "Akusztika",
        en: "Acoustics",
        file: { hu: "HIT/akusztika.json", en: "HIT/akusztika_en.json"}
    },
    {
        id: "digiatlisjelfeldolgozas",
        cluster: ["jelfeldolgozas"] ,
        hu: "Digitális jelfeldolgozás",
        en: "Digital signal processing",
        file: { hu: "MIT/digitálisjelfeldolgozás.json", en: "MIT/digitálisjelfeldolgozás_en.json"}
    },
    {
        id: "geometriaimodellezes",
        cluster: ["jelfeldolgozas"] ,
        hu: "3D geometriai modellezés",
        en: "3D geometric modelling",
        file: { hu: "IIT/számítógépesgeometria.json", en: "IIT/számítógépesgeometria_en.json"}
    },
    {
        id: "szamitogepesgrafikaesgepilatas",
        cluster: ["jelfeldolgozas", "orvosi"] ,
        hu: "Számítógépes grafika és gépi látás",
        en: "Computer graphics and machine vision",
        file: { hu: "IIT/számítógépesgrafika.json"}
    },
    {
        id: "elektromagnesesmezoszimulacio",
        cluster: ["elektrotechnika", "urtechnologia"] ,
        hu: "Elektromágneses mezőszimuláció és tervezés",
        en: "Electromagnetic simulation and design",
        file: { hu: "HVT/elektromágnesesmezők.json", en: "HVT/elektromágnesesmezők_en.json"}
    },
    {
        id: "orvosiinformatika",
        cluster: ["orvosi"] ,
        hu: "Orvosi informatika",
        en: "Biomedical informatics",
        file: { hu: "IIT/orvosiinformatika.json"}
    },
    {
        id: "mestersegesintelligencia",
        cluster: ["orvosi", "intelligens"] ,
        hu: "Mesterséges intelligencia",
        en: "Artificial intelligence",
        file: { hu: "MIT/mesterségesintelligencia.json", en: "MIT/mesterségesintelligencia_en.json"}
    },
    {
        id: "kognitivinformatika",
        cluster: ["orvosi", "itrendszerek"] ,
        hu: "Kognitív informatika",
        en: "Cognitive computing",
        file: { hu: "AUT/kognitívinformatika.json", en: "AUT/kognitívinformatika_en.json"}
    },
    {
        id: "beszedkommunikacio",
        cluster: ["orvosi", "intelligens"] ,
        hu: "Beszédkommunikáció és intelligens interakciók",
        en: "Speech communication and smart interactions",
        file: { hu: "TMIT/beszédtechnológia.json"}
    },
    {
        id: "vallalatiranyitasiinformatika",
        cluster: ["vallalati", "itrendszerek"] ,
        hu: "Vállalatirányítási informatika",
        en: "Business Informatics",
        file: { hu: "ETT/vállalatirányításiinformatika.json", en: "ETT/vállalatirányításiinformatika_en.json"}
    },
    {
        id: "adatesmediatartalom",
        cluster: ["vallalati", "intelligens"] ,
        hu: "Adat és médiatartalom",
        en: "Data science and content technologies",
        file: { hu: "TMIT/multimédiaéstartalomkezelés.json", en: "TMIT/multimédiaéstartalomkezelés_en.json"}
    },
    {
        id: "sztochasztikusrendszerek",
        cluster: ["halozatok", "intelligens"] ,
        hu: "Sztochasztikus rendszerek és adatmodellezés",
        en: "Stochastic systems and data modeling",
        file: { hu: "HIT/sztochasztikusrendszerek.json", en: "HIT/sztochasztikusrendszerek_en.json" }
    },
    {
        id: "diszkretmatematika",
        cluster: ["vallalati", "intelligens"] ,
        hu: "Diszkrét matematika",
        en: "Discrete mathematics",
        file: { hu: "SZIT/diszkrétmatematika.json", en: "SZIT/diszkrétmatematika_en.json"}
    },
    {
        id: "urtechnologia",        
        cluster: ["urtechnologia"] ,
        hu: "Űrtechnológia",
        en: "Space technology",
        file: { hu: "HVT/űrtechnológia.json", en: "HVT/űrtechnológia_en.json"}
    },
    {
        id: "radarestaverzekeles",        
        cluster: ["urtechnologia", "jelfeldolgozas"] ,
        hu: "Radar és távérzékelés",
        en: "Radar and Remote Sensing",
        file: { hu: "HVT/radaréstávérzékelés.json"}
    },
    {
        id: "antennakrediohullamterjedes",        
        cluster: ["urtechnologia"] ,
        hu: "Antennák, rádióhullám-terjedés és EMC ",
        en: "Antennas, Radiowave propagation and EMC",
        file: { hu: "HVT/antennákésemc.json"}
    },
    {
        id: "alkalmazottinformatika",        
        cluster: ["itrendszerek", "intelligens"] ,
        hu: "Alkalmazott informatika",
        en: "Applied informatics",
        file: { hu: "AUT/alkalmazottinformatika.json"}
    },
    {
        id: "szoftvermodellezes",        
        cluster: ["itrendszerek"] ,
        hu: "Szoftver modellezés",
        en: "Software modeling",
        file: { hu: "AUT/szoftvermodellezés.json", en: "AUT/szoftvermodellezés_en.json"}
    },
    {
        id: "szoftvertechnologia",        
        cluster: ["itrendszerek"] ,
        hu: "Szoftvertechnológia",
        en: "Software technology",
        file: { hu: "IIT/szoftvertechnológia.json"}
    },
    {
        id: "ftsrg",        
        cluster: ["itrendszerek", "beagyazott"] ,
        hu: "Kritikus rendszerek - ftsrg",
        en: "Critical systems - ftsrg",
        file: { hu: "MIT/ftsrg.json", en: "MIT/ftsrg_en.json"}
    },
    {
        id: "crysys",        
        cluster: ["itrendszerek", "intelligens"] ,
        hu: "Számítógépes biztonság - CrySyS",
        en: "Cyber security - CrySyS",
        file: { hu: "HIT/crysys.json", en: "HIT/crysys_en.json" }
    }
];

export const infrastructure = [
    { 
        path: "industry4", 
        hu: "Ipar 4.0 technológiai központ", 
        en: "Industry 4.0 technology center",
        cover: "./infrastructure/ipar4/i4tk-fig1.png",
        file: { hu: "industry_hu.json", en: "industry_en.json" }
    },
    { 
        path: "5g", 
        hu: "5G campus hálózat", 
        en: "5G campus network",
        cover: "./infrastructure/5g/5g-fig1.png",
        file: { hu: "5g_hu.json", en: "5g_en.json" }
    },
    { 
        path: "highpower", 
        hu: "Nagyfeszültségű Laboratórium", 
        en: "High Voltage Laboratory",
        cover: "./data/VET/images/nfl_2.png",
        file: { hu: "nagyfesz_hu.json", en: "nagyfesz_en.json" }
    },    
    { 
        path: "semiconductor", 
        hu: "Félvezetőtechnológiai labor", 
        en: "Semiconductor laboratory",
        cover: "./infrastructure/semiconductor/semi-fig1.png",
        file: { hu: "semiconductor_hu.json", en: "semiconductor_en.json" }
    },
    { 
        path: "drive", 
        hu: "Moduláris hibrid hajtáslánc labor", 
        en: "Modular Hybrid Drive System Laboratory",
        cover: "./infrastructure/hajtas/hajt-fig1.png",
        file: { hu: "hajtas_hu.json", en: "hajtas_en.json" }
    },
    { 
        path: "smartpower", 
        hu: "Smart power laboratórium", 
        en: "Smart Power Laboratory",
        cover: "./infrastructure/smartpower/sp-fig1.png",
        file: { hu: "smartpower_hu.json", en: "smartpower_en.json" }
    }    
];

export const deptEnglishNames = {
    "Automatizálási és Alkalmazott Informatikai Tanszék": "Department of Automation and Applied Informatics",
    "Hálózati Rendszerek és Szolgáltatások Tanszék": "Department of Networked Systems and Services",
    "Szélessávú Hírközlés és Villamosságtan Tanszék": "Department of Broadband Infocommunications and Electromagnetic Theory",
    "Irányítástechnika és Informatika Tanszék": "Department of Control Engineering and Information Technology",
    "Méréstechnika és Információs Rendszerek Tanszék": "Department of Measurement and Information Systems",
    "Számítástudományi és Információelméleti Tanszék": "Department of Computer Science and Information Theory",
    "Távközlési és Médiainformatikai Tanszék": "Department of Telecommunications and Media Informatics",
    "Elektronikus Eszközök Tanszéke": "Department of Electron Devices",
    "Villamos Energetika Tanszék": "Department of Electric Power Engineering",
    "Elektronikai Technológia Tanszék": "Department of Electronics Technology"
};